import $ from 'jquery';
import Splide from '@splidejs/splide';
import { CarSpec } from './script/CarList';
import 'reset-css';
import '@splidejs/splide/dist/css/splide.min.css';
import './index.scss';
import './style/main.scss';
import closeBtn from './images/invalid-name.svg';

let slide = new Splide('.splide', { start: 0 });

function PreRenderPC() {
  let _list = '';
  let _item = '';

  const strTemplate = (str, row) => `
    <div>
      <section class="preview__block flex p-4 box-border">
        ${str}
      </section>
      <div class="preview__spec hidden py-6" data-preview-col="${row}">
        <section>
          <div class="preview__spec__triangle"></div>
          <div>
            <div class="flex">
              <div class="preview__spec__name text-9xl mr-4"></div>
              <div class="preview__spec__list flex-1 mx-5">
                <table class="w-full">
                  <thead>
                    <tr class="border-b-2 border-solid border-gray-300">
                      <td class="p-2">車型</td>
                      <td class="p-2">新車牌價</td>
                      <td class="p-2">12期月租金</td>
                      <td class="p-2">24期月租金</td>
                      <td class="p-2">36期月租金</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-b-2 border-solid border-gray-300">
                      <td class="p-2"></td>
                      <td class="p-2"></td>
                      <td class="p-2"></td>
                      <td class="p-2"></td>
                      <td class="p-2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="preview__spec__close ml-4">
                <a><img src="./images/invalid-name.svg" alt="" /></a>
              </div>
            </div>
            <p class="text-center mt-4">
              ※租金包含車輛保險、汽車牌照燃料稅費、保養維修(定期保養及耗材更換)。
            </p>
          </div>
        </section>
      </div>
    </div>
  `;
  CarSpec.map((e, colIndex) => {
    _item += `
      <a class="preview__item w-1/3 flex justify-center" data-preview-item="${colIndex}" data-preview-col="${Math.ceil(
      (colIndex + 1) / 3
    )}">
        <img src="${e.imgUrl}" alt="" />
      </a>
    `;
    if ((colIndex + 1) % 3 === 0 || CarSpec.length === colIndex + 1) {
      _list += strTemplate(_item, Math.ceil(colIndex / 3));
      _item = '';
    }
  });

  $('.preview').append(_list);
}
PreRenderPC();
// pc開啟詳細資料
$('.preview .preview__item').click(function () {
  const parentWidth = $(this).parent('.preview__block').outerWidth();
  const currentItem = $(this).data('previewItem');
  const currentCol = $(this).data('previewCol');
  let list = '';
  const strTemplate = (str, title) => `
    <div class="preview__spec__triangle"></div>
    <div>
      <div class="flex">
        <div class="preview__spec__name text-9xl mr-4">${title}</div>
        <div class="preview__spec__list flex-1 mx-5">
          <table class="w-full">
            <thead>
              <tr class="border-b-2 border-solid border-gray-300">
                <td class="p-2">車型</td>
                <td class="p-2">新車牌價 </td>
                <td class="p-2">12期月租金</td>
                <td class="p-2">24期月租金</td>
                <td class="p-2">36期月租金</td>
              </tr>
            </thead>
            <tbody>
              ${str}
            </tbody>
          </table>
        </div>
        <div class="preview__spec__close ml-4"><a><img src="${closeBtn}" alt=""></a></div>
      </div>
      <p class="text-center mt-4">※租金包含車輛保險、汽車牌照燃料稅費、保養維修(定期保養及耗材更換)。</p>
    </div>
  `;
  const makeList = CarSpec[currentItem].categoryList.map((e) => {
    list += `
      <tr class="border-b-2 border-solid border-gray-300">
        <td class="p-2">${e.name}</td>
        <td class="p-2">${e.price}</td>
        <td class="p-2">${e.period_12}</td>
        <td class="p-2">${e.period_24}</td>
        <td class="p-2">${e.period_36}</td>
      </tr>
    `;
  });
  const allColSpec = $(`.preview__spec`);
  // $(`.preview__spec`).slideUp();
  allColSpec.each(function (i) {
    const currCol = $(allColSpec[i]);
    const currColNum = currCol.data('previewCol');
    if (currColNum !== currentCol) return currCol.slideUp();
  });
  $(`.preview__spec[data-preview-col="${currentCol}"] section > div`).remove();
  $(`.preview__spec[data-preview-col="${currentCol}"] section`).append(
    strTemplate(list, CarSpec[currentItem].seriesName)
  );
  $(
    `.preview__spec[data-preview-col="${currentCol}"] section .preview__spec__triangle`
  ).css({
    left:
      (parentWidth / 3) * (currentItem + 1 - (currentCol - 1) * 3) -
      parentWidth / 3 / 2 -
      50 +
      'px',
  });
  $(`.preview__spec[data-preview-col="${currentCol}"]`).slideDown();
  $('.preview__spec__close').click(function () {
    $(`.preview__spec`).slideUp();
  });
});

function PreRenderMobile() {
  // 車輛列表
  let _showcaseList = '';
  let _showcaseItem = '';
  const strTemplateShowcase = (str, row) => `
    <div>
      <section class="preview__block flex p-4 box-border">
        ${str}

      </section>
    </div>
    `;

  CarSpec.map((e, colIndex) => {
    _showcaseItem += `
      <a class="preview__item w-1/2" data-preview-item="${colIndex}" data-preview-col="${Math.ceil(
      (colIndex + 1) / 2
    )}">
        <img src="${e.imgUrl}" alt="" />
      </a>
    `;
    if ((colIndex + 1) % 2 === 0 || CarSpec.length === colIndex + 1) {
      _showcaseList += strTemplateShowcase(
        _showcaseItem,
        Math.ceil(colIndex / 2)
      );
      _showcaseItem = '';
    }
  });

  $('.preview__mobile').append(_showcaseList);

  // 車輛資料
  const a = $('.specMobile .splide__list');
  const strTemplate = (str, imgURL) => `
    <li class="splide__slide">
      <div class="w-full flex justify-center">
        <img class="mb-4" src="${imgURL}" alt="" />
      </div>
      <div>
        <table class="w-full">
          <thead>
            <tr class="border-b-2 border-solid border-gray-300">
              <td class="p-1 text-sm">車型</td>
              <td class="p-1 text-sm">新車牌價</td>
              <td class="p-1 text-sm text-center">月租金</td>
            </tr>
          </thead>
          <tbody>${str}</tbody>
        </table>
      </div>
    </li>
  `;
  let _list = '';
  CarSpec.map((e, index) => {
    let _item = '';
    e.categoryList.map(
      (f) =>
        (_item += `
      <tr class="border-b-2 border-solid border-gray-300">
        <td class="p-1 align-middle">${f.name}</td>
        <td class="p-1 align-middle">${f.price}</td>
        <td class="p-1">
          <div class="flex justify-between items-center whitespace-nowrap">
            <p class="text-center py-0.5 px-1" style="background: #e7e7e7; width: 46px;">12期</p>${f.period_12}
          </div>
          <div class="flex justify-between items-center whitespace-nowrap">
            <p class="text-center py-0.5 px-1" style="background: #e7e7e7; width: 46px;">24期</p>${f.period_24}
          </div>
          <div class="flex justify-between items-center whitespace-nowrap">
            <p class="text-center py-0.5 px-1" style="background: #e7e7e7; width: 46px;">36期</p>${f.period_36}
          </div>
        </td>
      </tr>
    `)
    );
    _list += strTemplate(_item, e.imgUrl);
  });
  a.append(_list);
}
PreRenderMobile();

// mobile開啟詳細資料
$('.preview__mobile .preview__item').click(function () {
  const currentItem = $(this).data('previewItem');
  const currentCol = $(this).data('previewCol');
  $('.specMobile').show();
  $('.main').hide();
  $(window).scrollTop(0);

  slide = new Splide('.splide', { start: currentItem });
  slide.mount();
});

$('.specMobile__back').click(function () {
  $('.specMobile').hide();
  $('.main').show();
  slide = null;
});

$(window).resize(function (event) {
  if ($(this).width() <= 992) {
    $(`.preview__spec`).slideUp();
  } else {
    $('.specMobile').hide();
    $('.main').show();
  }
});
